<template>
  <div class="v-upload">
    <v-btn color="primary" block @click="onUpload">
      <slot></slot>
    </v-btn>
    <input
      ref="input"
      :accept="accept"
      type="file"
      class="v-upload-input"
      @change="onFileSelected($event)"
    >
    <v-list v-if="show && fileList.length > 0">
      <v-list-tile v-for="item in fileList" :key="item.uid" :avatar="isPicture">
        <v-list-tile-action v-if="!isPicture" class="list-item-action">
          <v-icon v-if="item.type.indexOf('image') === 0">image</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title v-if="!isPicture">{{ item.name }}</v-list-tile-title>
          <v-dialog v-else width="500">
            <template v-slot:activator="{ on }">
              <v-img class="no-flex" :src="item.url" width="148">
                <v-layout align-center justify-center fill-height class="mask pointer" v-on="on">
                  <c-icon name="iconfangda" color="#ffffff" width="33px" height="33px"></c-icon>
                </v-layout>
              </v-img>
            </template>
            <v-card>
              <v-img :src="item.url"></v-img>
            </v-card>
          </v-dialog>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </div>
</template>

<script>
export default {
  props: {
    accept: {
      type: String,
      default: "image/*",
      validator(value) {
        // 这个值必须匹配下列字符串中的一个
        return (
          value.split(",").findIndex(item => {
            return (
              [
                "jpg",
                "png",
                "audio/*",
                "video/*",
                "image/*",
                ".xlsx",
                ".xls",
                "pdf"
              ].indexOf(item) > -1
            );
          }) > -1
        );
      }
    },
    show: {
      type: Boolean,
      default: true
    },
    showType: {
      type: String,
      default: "text" // text/picture
    },
    disabled: {
      type: Boolean,
      default: false
    },
    action: {
      type: String,
      default: ""
    },
    onSuccess: {
      type: Function,
      default() {
        return () => {};
      }
    },
    onError: {
      type: Function,
      default() {
        return () => {};
      }
    },
    limit: Number
  },
  data() {
    return {
      // 日后有需要的时候再支持多个文件
      fileList: [],
      tempIndex: 1,
      uploadFileName: "file"
    };
  },
  computed: {
    isPicture() {
      return this.showType === "picture";
    }
  },
  methods: {
    onUpload() {
      if (!this.disabled) {
        this.$refs.input.click();
      }
    },
    onFileSelected(event) {
      const files = event.target.files;
      if (!files) return;
      for (const item of files) {
        item.uid = this.getUid();
        item.url = URL.createObjectURL(item);
        if (this.limit && this.fileList.length >= this.limit) {
          // 替换最后一个
          this.fileList.splice(this.fileList.length - 1, 1, item);
        } else {
          this.fileList.push(item);
        }
        // 上传文件
        this.uploading(item);
      }
      this.$refs.input.value = null;
    },
    getUid() {
      return Date.now() + this.tempIndex++;
    },
    uploading(file) {
      if (this.action) {
        let formData = new FormData();
        formData.append(this.uploadFileName, file);
        this.$axios
          .post(this.action, formData, {
            headers: { "Content-Type": "multipart/form-data" }
          })
          .then(res => {
            this.onSuccess(res);
          })
          .catch(err => {
            this.onError(err);
          });
      } else {
        // 不需要上传的直接把 file 作为file作为回调函数参数调用
        this.onSuccess(file);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.v-upload {
  .v-upload-input {
    display: none;
  }
  .list-item-action {
    min-width: 30px;
  }
}
</style>

<style lang="scss">
.v-upload {
  .v-list__tile--avatar {
    height: 148px;
  }
}
</style>


